export const AccountDetails = {
  SET_PROFILE : "SET_PROFILE_DETAIL",
  SET_SELECTED_ACCOUNT: "SET_SELECTED_ACCOUNT",
  SET_SELECTED_TRANSACTIONS: "SET_SELECTED_TRANSACTIONS",
  SET_CURRENT_CLIENT: "SET_CURRENT_CLIENT",
  SET_PROFILE_PHOTO_URL: "SET_PROFILE_PHOTO_URL"
};
